import { useTranslation } from 'react-i18next';
import React from 'react';

export default function DevelopmentBanner() {
  const { t } = useTranslation();
  return (
    <div
      style={{
        width: '100%',
        background: '#fff4ce',
        color: '#7a3e00',
        borderBottom: '1px solid #f1c97a',
        padding: '10px var(--space-16)',
        fontSize: '14px',
        fontWeight: 700,
        textAlign: 'center',
        boxSizing: 'border-box',
      }}
      role="status"
      aria-live="polite"
    >
      {t('common.developmentNotice')}
    </div>
  );
}
